import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import BASE_URL from "../config";

const Domain = () => {
  const { pageName } = useParams(); // Get page name from URL params
  const [page, setPage] = useState({
    title: "",
    pagename: "",
    content: "",
    meta: "",
    active: 0, // Add active to the state to store the page's active status
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${BASE_URL}api/pages/find-by-slug/${pageName}`, {
          headers: { "Content-Type": "application/json" },
        });

        if (response.data) {
          setPage(response.data);
          document.title = response.data.title || "Default Title"; // Set the page title

          // Update the meta description
          const metaDescription = document.querySelector("meta[name='description']");
          if (metaDescription) {
            metaDescription.setAttribute("content", response.data.meta || "");
          } else {
            const meta = document.createElement("meta");
            meta.name = "description";
            meta.content = response.data.meta || "";
            document.head.appendChild(meta);
          }
        }
      } catch (error) {
        Swal.fire("Error", error.response?.data?.message || "Failed to fetch page", "error");
      } finally {
        setLoading(false);
      }
    };

    if (pageName) {
      fetchContent();
    }
  }, [pageName]);

  // Check if the page is active, and if not, display a message
  if (!loading && page.active !== 1) {
    return (
      <div className="container mt-4">
        <h2>Page Not Active</h2>
        <p>This page is currently inactive. Please check back later.</p>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h2>{page.pagename}</h2> {/* Display the page name */}
      <p><strong>Title:</strong> {page.title}</p>
      <p><strong>Meta Description:</strong> {page.meta}</p> {/* Display the meta description */}
      {loading ? <p>Loading...</p> : <div dangerouslySetInnerHTML={{ __html: page.content }} />}
    </div>
  );
};

export default Domain;
